export default [
  {
    path: '/expense-type',
    name: 'expense-type',
    component: () => import('@/pages/MainData/Expensetype/List.vue'),
    meta: {
      pageTitle: 'expenseType',
      breadcrumb: [{ text: 'mainData', active: true }],
      permission: 'viewExpenses',
    },
  },
  {
    path: '/income-type',
    name: 'income-type',
    component: () => import('@/pages/MainData/Incomestype/List.vue'),
    meta: {
      pageTitle: 'incomeType',
      breadcrumb: [{ text: 'mainData', active: true }],
      permission: 'viewIncomes',
    },
  },
  {
    path: '/banks',
    name: 'banks',
    component: () => import('@/pages/MainData/banks/List.vue'),
    meta: {
      pageTitle: 'banks',
      breadcrumb: [{ text: 'mainData', active: true }],
      permission: 'viewBanks',
    },
  },
  {
    path: '/safes',
    name: 'safes',
    component: () => import('@/pages/MainData/safes/List.vue'),
    meta: {
      pageTitle: 'safes',
      breadcrumb: [{ text: 'mainData', active: true }],
      permission: 'viewSafes',
    },
  },
  {
    path: '/areas',
    name: 'areas',
    component: () => import('@/pages/MainData/areas/List.vue'),
    meta: {
      pageTitle: 'areas',
      breadcrumb: [{ text: 'mainData', active: true }],
      permission: 'viewAreas',
    },
  },
  {
    path: '/agent-itineraries-status',
    name: 'agent-itineraries-status',
    component: () => import('@/pages/MainData/AgentItinerariesStatus/List.vue'),
    meta: {
      pageTitle: 'agentItinerariesStatus',
      breadcrumb: [{ text: 'mainData', active: true }],
      permission: 'viewAgentItinerariesStatus',
    },
  },
  {
    path: '/car-colors',
    name: 'car-colors',
    component: () => import('@/pages/MainData/CarsColor/List.vue'),
    meta: {
      pageTitle: 'carColors',
      breadcrumb: [{ text: 'mainData', active: true }],
      permission: 'viewColor',
    },
  },
  {
    path: '/tables',
    name: 'tables',
    component: () => import('@/pages/MainData/tabels/List.vue'),
    meta: {
      pageTitle: 'tables',
      breadcrumb: [{ text: 'mainData', active: true }],
      permission: 'viewTables',
    },
  },
  {
    path: '/cars',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: '',
        name: 'cars',
        component: () => import('@/pages/MainData/Cars/List.vue'),
        meta: {
          pageTitle: 'Cars',
          breadcrumb: [{ text: 'mainData', active: true }],
          permission: 'viewCars',
        },
      },
      {
        path: 'new',
        name: 'new-car',
        component: () => import('@/pages/MainData/Cars/Edit.vue'),
        meta: {
          pageTitle: 'new',
          breadcrumb: [{ text: 'mainData', active: true }],
          permission: 'addCars',
        },
      },
      {
        path: 'edit/:id',
        name: 'edit-car',
        props: true,
        component: () => import('@/pages/MainData/Cars/Edit.vue'),
        meta: {
          pageTitle: 'edit',
          breadcrumb: [{ text: 'mainData', active: true }],
          permission: 'editCars',
        },
      },
    ],
  },
  {
    path: '/drivers',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: '',
        name: 'drivers',
        component: () => import('@/pages/MainData/Drivers/List.vue'),
        meta: {
          pageTitle: 'Drivers',
          breadcrumb: [{ text: 'mainData', active: true }],
          permission: 'viewDrivers',
        },
      },
      {
        path: 'new',
        name: 'new-driver',
        component: () => import('@/pages/MainData/Drivers/Edit.vue'),
        meta: {
          pageTitle: 'new',
          breadcrumb: [{ text: 'mainData', active: true }],
          permission: 'addDrivers',
        },
      },
      {
        path: 'edit/:id',
        name: 'edit-driver',
        props: true,
        component: () => import('@/pages/MainData/Drivers/Edit.vue'),
        meta: {
          pageTitle: 'edit',
          breadcrumb: [{ text: 'mainData', active: true }],
          permission: 'editDrivers',
        },
      },
    ],
  },
  {
    path: '/cars-types',
    name: 'cars-types',
    component: () => import('@/pages/MainData/Carstypes/List.vue'),
    meta: {
      pageTitle: 'Cars Type',
      breadcrumb: [{ text: 'mainData', active: true }],
      permission: 'viewCarTypes',
    },
  },
  {
    path: '/discount-types',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: '',
        name: 'discount-types',
        component: () => import('@/pages/MainData/Discounttypes/List.vue'),
        meta: {
          pageTitle: 'Discount Types',
          breadcrumb: [{ text: 'mainData', active: true }],
          permission: 'viewDiscountTypes',
        },
      },
      {
        path: 'new',
        name: 'new-discount-types',
        component: () => import('@/pages/MainData/Discounttypes/Edit.vue'),
        meta: {
          pageTitle: 'newDiscountTypes',
          breadcrumb: [{ text: 'mainData', active: true }],
          permission: 'addDiscountTypes',
        },
      },
      {
        path: 'edit/:id',
        name: 'edit-discount-types',
        props: true,
        component: () => import('@/pages/MainData/Discounttypes/Edit.vue'),
        meta: {
          pageTitle: 'editDiscountTypes',
          breadcrumb: [{ text: 'mainData', active: true }],
          permission: 'editDiscountTypes',
        },
      },
    ],
  },
  {
    path: '/payment-methods',
    name: 'payment-methods',
    component: () => import('@/pages/MainData/Paymentmethods/List.vue'),
    meta: {
      pageTitle: 'Payment Methods',
      breadcrumb: [{ text: 'mainData', active: true }],
      permission: 'viewPaymentMethods',
    },
  },
  {
    path: '/projects',
    name: 'projects',
    component: () => import('@/pages/MainData/Projects/List.vue'),
    meta: {
      pageTitle: 'Projects',
      breadcrumb: [{ text: 'mainData', active: true }],
      permission: 'viewProjects',
    },
  },
  {
    path: '/accountGroups',
    name: 'account-groups',
    component: () => import('@/pages/MainData/accountGroups/List.vue'),
    meta: {
      pageTitle: 'accountGroups',
      breadcrumb: [{ text: 'mainData', active: true }],
      permission: 'viewAccountGroups',
    },
  },
  {
    path: '/safe-transaction',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: '',
        name: 'safe-transaction',
        component: () => import('@/pages/MainData/SafeTransactions/List.vue'),
        meta: {
          pageTitle: 'safeTransaction',
          breadcrumb: [{ text: 'mainData', active: true }],
          permission: 'viewSafeTransactions',
        },
      },
      {
        path: 'close/:id',
        name: 'safe-transaction-close',
        props: true,
        component: () => import('@/pages/MainData/SafeTransactions/CloseSafe.vue'),
        meta: {
          pageTitle: 'safeTransaction',
          breadcrumb: [{ text: 'mainData', active: true }],
          permission: 'closeSafes',
        },
      },
    ],
  },
  {
    path: '/exchange-destinations',
    name: 'exchange-destinations',
    component: () => import('@/pages/MainData/exchangeDestinations/List.vue'),
    meta: {
      pageTitle: 'exchangeDestinations',
      breadcrumb: [{ text: 'mainData', active: true }],
      permission: 'viewExchangeDestinations',
    },
  },
];
